import { render, staticRenderFns } from "./Alchemy.vue?vue&type=template&id=090c1ae8&scoped=true"
import script from "./Alchemy.vue?vue&type=script&lang=js"
export * from "./Alchemy.vue?vue&type=script&lang=js"
import style0 from "./Alchemy.vue?vue&type=style&index=0&id=090c1ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090c1ae8",
  null
  
)

export default component.exports